import {
    ActiveButton,
    BackButton,
    BorderDiv,
    TextGrid,
    TopText,
} from '../users/style';

import back_arrow from '../../common/images/back_arrow.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import { Status } from '../trade/style';
import { Loader } from '../../common/component';
import { useGetSingleContentQuery } from '../../store/topicApi';
import { ContentDetails } from './contentDetails';

export const ViewContent = () => {
    const param = useParams();
    const contentId = param?.id as string;

    const navigate = useNavigate();
    const { data: contentData, isLoading } =
        useGetSingleContentQuery(contentId);

    return (
        <div className="pb-4">
            <div className="d-flex align-items-center my-2">
                <BackButton onClick={() => navigate(-1)}>
                    <img src={back_arrow} alt="" /> Back
                </BackButton>
                <TopText>
                    {' '}
                    <span>/Content</span> / View Content
                </TopText>
            </div>
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <BorderDiv className=" my-4 ">
                        <Col sm={8}>
                            <TextGrid>
                                <ActiveButton>Content details</ActiveButton>
                            </TextGrid>
                        </Col>
                        <Col className="d-flex align-items-center justify-content-end mb-2 mb-sm-0">
                            <Status>
                                {contentData?.data?.status ? (
                                    <p style={{ color: '#34a853' }}>Active</p>
                                ) : (
                                    'Inactive'
                                )}
                            </Status>
                        </Col>
                    </BorderDiv>
                    {<ContentDetails />}
                </>
            )}
        </div>
    );
};
